import { useState } from "react";

function CopyableBox({ label, content }: { label: string; content: string | null | undefined }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    if (!content) return;
    navigator.clipboard.writeText(content)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
      });
  };

  return (
    <div className="relative bg-gray-100 rounded-md p-4 min-h-[6rem] flex flex-col w-full">
      {/* Label arriba, NO copiable */}
      <div className="flex justify-between items-center mb-2">
        <span className="mb-1 font-semibold text-black select-none">{label}</span>
        <button
          onClick={handleCopy}
          type="button"
          aria-label={`Copiar contenido de ${label}`}
          className="flex items-center space-x-1 px-2 py-1 text-[10px] font-medium text-gray-700 bg-gray-300 rounded hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-500"
          title={copied ? "Copied" : "Copy"}
        >
          {!copied ? (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <rect x="9" y="9" width="12" height="12" rx={2} ry={2} strokeLinecap="round" strokeLinejoin="round" />
              <rect x="3" y="3" width="12" height="12" rx={2} ry={2} strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          )}
          <span>{copied ? "Copied" : "Copy"}</span>
        </button>
      </div>

      {/* Contenido con scroll vertical limitado */}
      <div className="whitespace-pre-wrap overflow-y-auto text-[10px] leading-snug max-h-[20rem]">
        {content || <em className="text-gray-500">No content available.</em>}
      </div>
    </div>
  );
}

export default CopyableBox;
